module.exports = __webpack_public_path__ + "img/929.6fad3ea8.gif";